import { CloseButton } from 'components/Button';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { th, zIndexes, variants } from 'style/theme';
import { sizes } from 'style';

export const ModalCloseButton = styled(CloseButton)`
  position: absolute;
  top: 10px;
  right: 8px;
  z-index: 2;

  ${(props) =>
    props.variant?.includes('rh')
      ? css`
          width: 32px;
          height: 32px;
          top: 32px;
          bottom: 32px;
          right: 40px;
          display: flex;
          align-items: center;

          svg {
            font-size: 20px;
            flex: auto;
            top: 0px;
          }
        `
      : ``}
`;

export const ModalHeader = styled.div`
  padding: 32px;
  padding-right: 40px;
  padding-left: 40px;
  width: 100%;
  background-color: ${th('colors.modalHeaderBg')};
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 16px 16px 0 0;
  color: ${th('colors.modalText')};

  ${({ headingColor }) =>
    headingColor &&
    css`
      color: ${th(`colors.${headingColor}`)};
    `};

  ${(props) =>
    props.variant?.includes('rh')
      ? css`
          background-color: ${th('colors.blueViolet')};
        `
      : ``}

  @media ${sizes.tabletPortrait} {
    ${(props) => {
      switch (props.variant) {
        case 'rhFluid':
          return css``;
        default:
          return css`
            padding: 16px 32px;
          `;
      }
    }}
  }

  @media ${sizes.tabletPortrait} {
    ${variants('thickness', {
      thick: css`
        padding-left: 38px;
        height: 75px;
      `
    })}

    ${(props) =>
      props.variant?.includes('rh')
        ? css`
            height: 96px;
            padding-left: 40px;
            h6 {
              font-size: 24px;
            }
          `
        : ``}
  }
`;

export const ModalBody = styled.div`
  padding: 12px;
  width: 100%;
  color: ${th('colors.modalText')};
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
  border-radius: 0 0 16px 16px;

  ${(props) => {
    switch (props.variant) {
      case 'rh':
        return css`
          padding: 24px;
          background-color: #2f2f83;
        `;
      case 'rhFluid':
        return css`
          padding: 24px;
          background-color: ${th('colors.indigoDark2')};
        `;
      case 'fullScreen':
        return css`
          padding: 0;
          background-color: ${th('colors.white')};
          border-radius: 0;
        `;
      default:
        return css``;
    }
  }}

  @media ${sizes.mobileMedium} {
    padding: 24px;
    padding-top: 20px;
  }

  @media ${sizes.tabletPortrait} {
    ${variants('thickness', {
      normal: css`
        padding: 20px 32px 24px 32px;
      `,
      thick: css`
        padding: 38px;
      `
    })}

    ${(props) =>
      props.variant?.includes('rh')
        ? css`
            font-size: 16px;
            padding: 40px;
          `
        : ``}
    
    ${(props) => {
      switch (props.variant) {
        case 'rh':
          return css`
            padding-bottom: 40px;
          `;
        default:
          return css``;
      }
    }}
  }

  ${({ hasHeader }) =>
    !hasHeader &&
    css`
      padding-right: 38px;
    `}

  > ul {
    margin: 4px 0;
    padding-left: 24px;
  }
`;

export const Backdrop = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: ${({ variant }) => (variant === 'fullScreen' ? 0 : '40px 5% 40px 5%')};

  overflow: scroll;
  background-color: ${th('colors.backdrop')};
  z-index: ${zIndexes.overlay};

  ${({ isScrollable }) =>
    !isScrollable &&
    css`
      @media ${sizes.tabletPortrait} {
        align-items: center;
        overflow: scroll;
        padding-top: 0px;
        padding-bottom: 0px;
        height: 100vh;
      }
    `}
`;

export const ModalContainer = styled(motion.div)`
  width: 600px;
  max-width: 100%;
  background-color: ${th('colors.modalBg')};
  color: ${th('colors.primaryText')};
  border-radius: 16px;
  position: relative;

  ${variants('background', {
    secondary: css`
      background-color: ${th('colors.modalBg.secondary')};
    `,
    primary: css`
      background-color: ${th('colors.modalBg.primary')};
    `
  })}

  ${(props) => {
    switch (props.variant) {
      case 'rh':
        return css`
          width: 592px;
          border-radius: 16px;
        `;
      case 'rhFluid':
        return css`
          width: 90%;
          border-radius: 16px;

          @media ${sizes.tabletPortrait} {
            width: fit-content;
          }
        `;
      case 'fullScreen':
        return css`
          width: 100%;
          height: 100%;
          border-radius: 0;
        `;
      default:
        return css``;
    }
  }}

  ${variants('color', {
    dark: css`
      color: ${th('colors.black')};
    `,
    light: css`
      color: ${th('colors.white')};
    `
  })}
`;
